import React from "react"
import EmbeddedExperienceBooking from "../Embedded/ExperienceBooking"
// import GuestHeader from "layoutsV2/client/GuestHeader"
// import FirstLoading from "modules/loader-watchers/FirstLoading"
// import { useSelector } from "react-redux"

const GuestClientBooking = () => {
  // const { loading: isCaptureLoading } = useSelector((state) => state.paymentProvider.capturePayPalOrder)

  return (
    <>
      {/* <GuestHeader /> */}
      {/* <FirstLoading loading={isCaptureLoading}> */}
      <EmbeddedExperienceBooking mode={"clientBooking"} />
      {/* </FirstLoading> */}
    </>
  )
}

export default GuestClientBooking
